'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import { AiReviewBlockWrapper, AIReviewHeader, AIReviewBody, AIReviewContent, TextPreview, PreviewList, AIReviewFooter, AIReviewFooterItem, ContentWrapper, SelectResumeWrapper, SelectResume, ButtonWrapper, ScoreWrapper, ScoreItem } from './AICVReview.css.js';
import AiTagIcon from './icons/AiTagIcon.js';
import LabelSelectResume from './LabelSelectResume.js';
import AIComboChartIcon from './icons/AIComboChartIcon.js';
import AIMoneyStackIcon from './icons/AIMoneyStackIcon.js';
import AILeaderboardIcon from './icons/AILeaderboardIcon.js';
import AIPeopleIcon from './icons/AIPeopleIcon.js';
import CandidateCompareIcon from './icons/CandidateCompareIcon.js';
import Typography from '../../Typography/index.js';
import ButtonAI from '../../ButtonAI/index.js';
import AIReviewCV from '../../AIReviewCV/index.js';
import Button from '../../Button/index.js';
import MultipleRadio from '../../MultipleRadio/index.js';
import AiCVPreviewImage from './AiCVPreviewImage.js';
import JobFitIcon from './icons/JobFitIcon.js';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import '../../Images/AddIcon/index.js';
import '../../Images/AddOutlinedIcon/index.js';
import '../../Images/Trash/index.js';
import '../../Images/Pencil/index.js';
import '../../Images/ArrowRoundedLeft/index.js';
import '../../Images/ArrowRoundedRight/index.js';
import '../../Images/AwardsIcon/index.js';
import '../../Images/BonusIcon/index.js';
import '../../Images/CanteenIcon/index.js';
import '../../Images/CheckTagIcon/index.js';
import CloseIcon from '../../Images/CloseIcon/index.js';
import '../../Images/CommercialIcon/index.js';
import '../../Images/CompanySizeIcon/index.js';
import '../../Images/ContactIcon/index.js';
import '../../Images/CopyIcon/index.js';
import '../../Images/DefaultAvatar/index.js';
import '../../Images/DangerIcon/index.js';
import '../../Images/ExternalLinkIcon/index.js';
import EyesOpenIcon from '../../Images/EyesOpenIcon/index.js';
import '../../Images/FacebookIcon/index.js';
import '../../Images/ForwardIcon/index.js';
import '../../Images/HealthcarePlanIcon/index.js';
import '../../Images/HeartIcon/index.js';
import '../../Images/HeartOutlineIcon/index.js';
import '../../Images/HideIcon/index.js';
import '../../Images/KindergartenIcon/index.js';
import '../../Images/LaptopIcon/index.js';
import '../../Images/LibraryIcon/index.js';
import '../../Images/LinkIcon/index.js';
import '../../Images/LinkedInIcon/index.js';
import '../../Images/LoadingCircleIcon/index.js';
import '../../Images/MarkerIcon/index.js';
import '../../Images/MobileIcon/index.js';
import '../../Images/PaidLeaveIcon/index.js';
import '../../Utils/constants.js';
import '../../Images/SearchIcon/index.js';
import '../../Images/ShareIcon/index.js';
import '../../Images/ReportIcon/index.js';
import '../../Images/StatsIcon/index.js';
import '../../Images/TeamActivitiesIcon/index.js';
import '../../Images/ThreeDotIcon/index.js';
import '../../Images/TrainingIcon/index.js';
import '../../Images/TransportationIcon/index.js';
import '../../Images/TrashIcon/index.js';
import '../../Images/TravelOpportunitiesIcon/index.js';
import '../../Colors/index.js';
import '../../Images/VerticalMoreIcon/index.js';
import '../../Images/VoucherIcon/index.js';
import '../../Images/WowCVIcon/index.js';
import '../../Images/WorkingLocationIcon/index.js';
import '../../Images/ZaloIcon/index.js';
import '../../Images/FacebookLogoIcon/index.js';
import '../../Images/GoogleLogoIcon/index.js';
import '../../Images/DragReorderIcon/index.js';
import '../../Images/CheckIcon/index.js';
import '../../Images/CircleChecked/index.js';
import '../../Images/SalaryIcon/index.js';
import '../../Images/BriefcaseIcon/index.js';
import '../../Images/GraduationCapIcon/index.js';
import '../../Images/EnvelopeIcon/index.js';
import '../../Images/AddFilledIcon/index.js';
import '../../Images/HomeIcon/index.js';
import '../../Images/PhoneIcon/index.js';
import '../../Images/AttachIcon/index.js';
import '../../Images/FilterIcon/index.js';
import '../../icons/WarnIcon.js';
import '../../icons/AccountSettingsIcon.js';
import '../../icons/DashboardIcon.js';
import '../../icons/JobAlertsIcon.js';
import '../../icons/MyCompaniesIcon.js';
import '../../icons/MyJobsIcon.js';
import '../../icons/MyProfileIcon.js';
import '../../icons/ProfileSettingsIcon.js';
import '../../icons/LanguageIcon.js';
import '../../icons/BenefitGroupIcons/ActivityIcon.js';
import '../../icons/BenefitGroupIcons/AwardsIcon.js';
import '../../icons/BenefitGroupIcons/BonusIcon.js';
import '../../icons/BenefitGroupIcons/CanteenIcon.js';
import '../../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../../icons/BenefitGroupIcons/LaptopIcon.js';
import '../../icons/BenefitGroupIcons/LibraryIcon.js';
import '../../icons/BenefitGroupIcons/MoreIcon.js';
import '../../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../../icons/BenefitGroupIcons/PhoneIcon.js';
import '../../icons/BenefitGroupIcons/TrainingIcon.js';
import '../../icons/BenefitGroupIcons/TransportationIcon.js';
import '../../icons/BenefitGroupIcons/TravelIcon.js';
import '../../icons/BenefitGroupIcons/VoucherIcon.js';
import '../../icons/BenefitGroupIcons/Physics.js';
import '../../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../../icons/AccountCenterGroupIcons/Language.js';
import '../../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../../icons/AccountCenterGroupIcons/Lawyer.js';
import '../../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../../icons/InfoOverviewGroupIcons/Location.js';
import '../../icons/InfoOverviewGroupIcons/Education.js';
import '../../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/Admin.js';
import '../../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../../icons/InfoOverviewGroupIcons/Address.js';
import '../../icons/InfoOverviewGroupIcons/Salary.js';
import '../../icons/InfoOverviewGroupIcons/Gender.js';
import '../../icons/InfoOverviewGroupIcons/Translator.js';
import '../../icons/InfoOverviewGroupIcons/Birthday.js';
import '../../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../../icons/MiscGroupIcons/Link.js';
import '../../icons/MiscGroupIcons/History.js';
import '../../icons/MiscGroupIcons/Favorite.js';
import '../../icons/MiscGroupIcons/UnFavorite.js';
import '../../icons/MiscGroupIcons/ProductDocuments.js';
import '../../icons/MiscGroupIcons/Star.js';
import '../../icons/SocialMediaGroupIcons/Facebook.js';
import '../../icons/SocialMediaGroupIcons/Linkedin.js';
import '../../icons/SocialMediaGroupIcons/Twitter.js';
import '../../icons/SocialMediaGroupIcons/Zalo.js';
import '../../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../../icons/SocialMediaGroupIcons/Share.js';
import '../../icons/NavigationGroupIcons/Vertical.js';
import '../../icons/NavigationGroupIcons/More.js';
import '../../icons/NavigationGroupIcons/Close.js';
import '../../icons/NavigationGroupIcons/Expand.js';
import '../../icons/NavigationGroupIcons/Collapse.js';
import '../../icons/NavigationGroupIcons/Next.js';
import '../../icons/NavigationGroupIcons/Back.js';
import '../../icons/NavigationGroupIcons/ExternalLink.js';
import '../../icons/NavigationGroupIcons/RightArrow.js';
import '../../icons/AlertGroupIcons/SuccessIcon.js';
import '../../icons/AlertGroupIcons/CareerPath.js';
import '../../icons/AlertGroupIcons/Hot.js';
import '../../icons/AlertGroupIcons/Urgent.js';
import '../../icons/FormActionGroupIcons/Exchange.js';
import '../../icons/FormActionGroupIcons/AddTag.js';
import '../../icons/RewardsTypeGroupIcons/Hospital.js';
import '../../Images/DoubleTickIcon/index.js';
import '../../Images/BellIcon/index.js';
import '../../Images/AiIcon/index.js';
import CircleArrowRightIcon from '../../Images/CircleArrowRightIcon/index.js';
import '../../Images/MiniAiIcon/index.js';
import '../../icons/OrderManagementIcon.js';
import '../../Images/TwinkleLinearGradientIcon/index.js';
import { CustomPopup } from '../AIBanner.css.js';
import useHog from '../../PostHog/hooks/useHog/index.js';
import { isMobile } from '../../Utils/helpers.js';
import '../../UploadResumeModal/type.js';
import { showLogin } from '../../Utils/showLogin.js';

var AIReviewBlock = function (props) {
    var _a;
    var user = props.user, langCode = props.langCode, cvReviews = props.cvReviews, env = props.env, t = props.t, cvReviewTrial = props.cvReviewTrial, showBannerState = props.showBannerState;
    var baseUrl = env.baseUrl, baseMsUrl = env.baseMsUrl, baseImageUrl = env.baseImageUrl;
    var showBanner = showBannerState[0], setShowBanner = showBannerState[1];
    var _b = useState(false), isShow = _b[0], setShow = _b[1];
    var _c = useState(''), selectedCVId = _c[0], setSelectedCVId = _c[1];
    var tracking = useHog().tracking;
    var optionAIResumes = useMemo(function () {
        return cvReviews.map(function (item) {
            return {
                id: item.attributes.soNo,
                name: item.attributes.fileName
            };
        });
    }, [cvReviews]);
    var selectedCV = useMemo(function () {
        var cv = cvReviews.filter(function (item) { return item.attributes.soNo === selectedCVId; });
        return cv.length > 0 ? cv[0] : null;
    }, [cvReviews, selectedCVId]);
    var cvScore = useMemo(function () {
        if (!selectedCV) {
            return '';
        }
        var text = '';
        if (selectedCV.attributes.score < 50) {
            text = t('Low');
        }
        if (selectedCV.attributes.score >= 50 && selectedCV.attributes.score < 70) {
            text = t('Medium');
        }
        if (selectedCV.attributes.score >= 70 && selectedCV.attributes.score < 90) {
            text = t('High');
        }
        if (selectedCV.attributes.score >= 90) {
            text = t('Very high');
        }
        return "".concat(selectedCV.attributes.score, "% ").concat(text);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCV]);
    var cvRank = useMemo(function () {
        if (!selectedCV) {
            return '';
        }
        return "".concat(t('Rank'), " #").concat(selectedCV.attributes.rank);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCV]);
    var onClickAIReview = function () {
        var showDialogSelectResume = function () {
            setShow(true);
            setShowBanner(false);
        };
        tracking({
            eventName: 'js_cv_review:click_use'
        });
        if (!(user === null || user === void 0 ? void 0 : user.accessToken)) {
            // Not logged in? Then show login modal
            // and callback to show dialog select resume
            showLogin({
                langCode: langCode,
                onLoggedIn: showDialogSelectResume
            });
            return;
        }
        // Show dialog select resume
        showDialogSelectResume();
    };
    var onClickViewReview = function (e) {
        e.stopPropagation();
        var url = "".concat(t('/cv-review'), "/").concat(selectedCV === null || selectedCV === void 0 ? void 0 : selectedCV.attributes.soNo);
        window.location.assign(url);
    };
    useEffect(function () {
        if (cvReviews.length > 0) {
            setSelectedCVId(cvReviews[0].attributes.soNo);
        }
    }, [cvReviews]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(CustomPopup, { isShow: showBanner, lang: langCode, custom: { header: React__default.createElement(React__default.Fragment, null), footer: React__default.createElement(React__default.Fragment, null), isPopupCenter: true }, onClickOutside: function () { return setShowBanner(false); } },
            React__default.createElement(AiReviewBlockWrapper, { id: 'AI-Review' },
                React__default.createElement(AIReviewHeader, null,
                    React__default.createElement("div", null,
                        React__default.createElement(Typography, { name: 'title', size: 'large', color: '#fff' }, t('Competitive Analysis')),
                        React__default.createElement(Typography, { name: 'label', size: 'small', color: '#fff', style: { marginTop: 8 } },
                            React__default.createElement(AiTagIcon, { style: { marginRight: 4 } }),
                            "VietnamWorks AI")),
                    React__default.createElement(Button, { className: 'close-btn', isRounded: true, isIcon: true, type: 'opacity', onClick: function () { return setShowBanner(false); } },
                        React__default.createElement(CloseIcon, { fill: '#fff' }))),
                React__default.createElement(AIReviewBody, { imageUrl: encodeURI("".concat(baseImageUrl, "/images/ai_cv_review_bg_2.png")) }, cvReviews.length === 0 ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(AIReviewContent, null,
                        React__default.createElement(TextPreview, null,
                            React__default.createElement(PreviewList, null,
                                React__default.createElement("li", null,
                                    React__default.createElement(AIPeopleIcon, null),
                                    isMobile()
                                        ? t('How you match this job?')
                                        : t('What percentage are you suitable for this position?')),
                                React__default.createElement("li", null,
                                    React__default.createElement(AILeaderboardIcon, null),
                                    isMobile()
                                        ? t('Your ranking vs. other application?')
                                        : t('What is your ranking compared to other applicants?')),
                                React__default.createElement("li", null,
                                    React__default.createElement(AIMoneyStackIcon, null),
                                    isMobile()
                                        ? t('Market salary for this position?')
                                        : t('What is the market salary for similar positions?')),
                                React__default.createElement("li", null,
                                    React__default.createElement(AIComboChartIcon, null),
                                    isMobile()
                                        ? t('Hiring demand for this position?')
                                        : t('Is the demand for this position on the market high or low?')))),
                        React__default.createElement(AiCVPreviewImage, __assign({}, props))),
                    React__default.createElement(AIReviewFooter, null,
                        React__default.createElement(AIReviewFooterItem, null,
                            React__default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 4 } },
                                !isMobile() && (React__default.createElement(Typography, { name: 'body', size: 'small', color: '#fff' }, t('Price'))),
                                React__default.createElement(Typography, { name: 'title', size: 'small', color: '#fff' },
                                    "29.000",
                                    React__default.createElement("u", null, "\u0111"),
                                    " / ",
                                    t('time'))),
                            (cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial) ? (React__default.createElement(Typography, { name: 'body', size: 'small', color: '#fff' }, isMobile()
                                ? t('{0} free trial remaining').replace('{0}', cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial.toString())
                                : t('You have {0} free trial').replace('{0}', cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial.toString()))) : null),
                        React__default.createElement(ButtonAI, { onClick: onClickAIReview },
                            (cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial) ? t('Try for free') : t('View analysis now'),
                            ' ',
                            !isMobile() && React__default.createElement(CircleArrowRightIcon, null))))) : (React__default.createElement(ContentWrapper, null,
                    React__default.createElement(SelectResumeWrapper, null,
                        React__default.createElement(SelectResume, null,
                            React__default.createElement(MultipleRadio, { name: 'select-resume-ai', options: optionAIResumes, value: selectedCVId, onChange: function (_a) {
                                    var value = _a.value;
                                    return setSelectedCVId(value);
                                }, customValue: function (value) {
                                    var selectedResumeInfo = cvReviews.filter(function (item) { return item.attributes.soNo === value.id; });
                                    var fileName = selectedResumeInfo.length > 0
                                        ? selectedResumeInfo[0].attributes.fileName
                                        : '';
                                    var createdOn = selectedResumeInfo.length > 0
                                        ? selectedResumeInfo[0].attributes.createdOn
                                        : '';
                                    return (React__default.createElement(LabelSelectResume, { fileName: fileName, createdOn: createdOn, t: t }));
                                }, dropdownStyle: {
                                    maxHeight: 400
                                }, dropdown: {
                                    floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true
                                    }
                                }, selectStyle: {
                                    height: 'auto',
                                    paddingRight: 12,
                                    borderRadius: 12
                                } })),
                        React__default.createElement(ButtonWrapper, null,
                            React__default.createElement(Button, { type: 'highlight', outline: 'outline', onClick: function (e) { return onClickViewReview(e); } }, !isMobile() ? t('See report') : React__default.createElement(EyesOpenIcon, null)))),
                    React__default.createElement(ScoreWrapper, null,
                        React__default.createElement(ScoreItem, null,
                            React__default.createElement(JobFitIcon, { width: 36, height: 36 }),
                            React__default.createElement("div", null,
                                React__default.createElement(Typography, { name: 'body', size: 'medium' }, t('Matching rate to job requirements')),
                                React__default.createElement(Typography, { name: 'title', size: 'medium' }, cvScore))),
                        React__default.createElement(ScoreItem, null,
                            React__default.createElement(CandidateCompareIcon, { width: 36, height: 36 }),
                            React__default.createElement("div", null,
                                React__default.createElement(Typography, { name: 'body', size: 'medium' }, t('Comparison with other applicants')),
                                React__default.createElement(Typography, { name: 'title', size: 'medium' }, cvRank)))),
                    React__default.createElement(Row, { style: { marginTop: 16 } },
                        React__default.createElement(Col, { xs: 24 },
                            React__default.createElement(ButtonAI, { onClick: onClickAIReview, style: { width: '100%' } }, t('Evaluate another CV'))))))))),
        React__default.createElement(AIReviewCV, __assign({ showState: [isShow, setShow], accessToken: (_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '', baseMsUrl: baseMsUrl, baseUrl: baseUrl, isTrial: !!(cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial) }, props))));
};

export { AIReviewBlock as default };
//# sourceMappingURL=index.js.map
